import { render, staticRenderFns } from "./FrenchAddress.vue?vue&type=template&id=4e584846&scoped=true"
import script from "./FrenchAddress.vue?vue&type=script&lang=js"
export * from "./FrenchAddress.vue?vue&type=script&lang=js"
import style0 from "./FrenchAddress.vue?vue&type=style&index=0&id=4e584846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e584846",
  null
  
)

export default component.exports